import { jsx as _jsx } from "nativewind/jsx-runtime";
import React from 'react';
import ToiletReviewItem from '@/components/ToiletReviewItem';
export default function PlaceDetailPlaceToiletReviewItem({ placeId, review, }) {
    return (_jsx(ToiletReviewItem, { placeId: placeId, review: review, variant: "detail" }));
}
